import { ColumnsType } from "antd/es/table";
import { SelectList } from "api/baseApiResponseModel/BaseApiResponseModel";
import { FilterAttributes } from "components/generalComponents/filterComponents/model/FilterComponentsModel";
import dayjs from "dayjs";
import { strings } from "utils/localizedStrings";
import { AppProfileModel, AssetsClassify, ParticipantsModel } from '../../../api/repositories/appProfileRegister/models/AppProfileModel';

enum statusEnum {
  Init = 0,
  Processing = 1,
  Approving = 2,
  Completed = 3,
  Rejected = 4,
  Cancel = 5,
  Expried = 6,
  Approved = 99
};

enum typeEnum {
  Verified = 0
}

enum participantTypeEnum {
  Single = 0,
  Organization = 1
}

enum participantStatusEnum {
  Init = 0,
  Approving = 1,
  Signed = 2,
  Expried = 3
}

const statusOption: SelectList[] = [
  { label: strings.GlobalLabels.All, value: "" },
  { label: strings.AppProfileRegister.Status.Init, value: statusEnum.Init, color: "purple" },
  { label: strings.AppProfileRegister.Status.Proccessing, value: statusEnum.Processing, color: "purple" },
  { label: strings.AppProfileRegister.Status.Approving, value: statusEnum.Approving, color: "orange" },
  { label: strings.AppProfileRegister.Status.Approved, value: statusEnum.Approved, color: "blue" },
  { label: strings.AppProfileRegister.Status.Completed, value: statusEnum.Completed, color: "green" },
  { label: strings.AppProfileRegister.Status.Rejected, value: statusEnum.Rejected, color: "red" },
  { label: strings.AppProfileRegister.Status.Cancel, value: statusEnum.Cancel, color: "red" },
  { label: strings.AppProfileRegister.Status.Expried, value: statusEnum.Expried, color: "red" },
];

const typeOption: SelectList[] = [
  { label: strings.GlobalLabels.All, value: "" },
  { label: strings.AppProfileRegister.Type.Verified, value: typeEnum.Verified },
];

const participantTypeOption: SelectList[] = [
  { label: strings.GlobalLabels.All, value: "" },
  { label: strings.AppProfileRegister.Labels.Participants.Single, value: participantTypeEnum.Single },
  { label: strings.AppProfileRegister.Labels.Participants.Organization, value: participantTypeEnum.Organization },
];

const participantStatusOption: SelectList[] = [
  { label: strings.GlobalLabels.All, value: "" },
  { label: strings.AppProfileRegister.Status.Init, value: participantStatusEnum.Init, color: "blue" },
  { label: strings.AppProfileRegister.Status.Proccessing, value: participantStatusEnum.Approving, color: "purple" },
  { label: strings.AppProfileRegister.Status.Signed, value: participantStatusEnum.Signed, color: "green" },
  { label: strings.AppProfileRegister.Status.Expried, value: participantStatusEnum.Expried, color: "red" },
];

const verifyStatusOption: SelectList[] = [
  { label: strings.GlobalLabels.All, value: "", color: "" },
  { label: strings.AppProfileRegister.Labels.IsVerified, value: true, color: "green" },
  { label: strings.AppProfileRegister.Labels.NotVerified, value: false, color: "red" },
]

const filterAttributes: FilterAttributes[] = [
  {
    colLg: 4,
    defaultValue: '',
    filterName: 'status',
    filterType: 'select',
    labelName: strings.AppProfileRegister.Labels.Status,
    options: statusOption,
  },
  {
    colLg: 4,
    defaultValue: '',
    filterName: 'type',
    filterType: 'select',
    labelName: strings.AppProfileRegister.Labels.Type,
    options: typeOption,
  },
  {
    colLg: 4,
    defaultValue: '',
    filterName: 'phoneNumber',
    filterType: 'input',
    labelName: strings.AppProfileRegister.Labels.PhoneNumber,
    options: [],
    placeholder: strings.GlobalLabels.Placeholder + strings.AppProfileRegister.Labels.PhoneNumber.toLowerCase(),
  },
  {
    colLg: 4,
    defaultValue: '',
    filterName: 'code',
    filterType: 'input',
    labelName: strings.AppProfileRegister.Labels.Code,
    options: [],
    placeholder: strings.GlobalLabels.Placeholder + strings.AppProfileRegister.Labels.Code.toLowerCase(),
  },
  {
    colLg: 4,
    defaultValue: '',
    filterName: 'providerPreviewCode',
    filterType: 'input',
    labelName: strings.AppProfileRegister.Labels.ProviderPreviewCode,
    options: [],
    placeholder: strings.GlobalLabels.Placeholder + strings.AppProfileRegister.Labels.ProviderPreviewCode.toLowerCase(),
  },
  {
      colLg: 4,
      defaultRangeDay: [dayjs().startOf('month'), dayjs()],
      filterName: 'date',
      filterType: 'range-date',
      labelName: strings.AppTransactionHistory.Labels.Time,
      options: [],
    }
] as FilterAttributes[];

const columns: ColumnsType<AppProfileModel> = [
  {
    title: strings.AppProfileRegister.Labels.Code,
    dataIndex: 'code',
    key: 'code',
    align: 'center',
  },
  {
    title: strings.AppProfileRegister.Labels.PhoneNumber,
    dataIndex: 'phone',
    key: 'phone',
    align: 'center',
    render: (_, record) => record?.userContracts?.[0]?.phoneNumber
  },
  {
    title: strings.AppProfileRegister.Labels.Name,
    dataIndex: 'name',
    key: 'name',
    align: 'center',
  },
  {
    title: strings.AppProfileRegister.Labels.ProviderPreviewCode,
    dataIndex: 'providerPreviewCode',
    key: 'providerPreviewCode',
    align: 'center',
  },
  {
    title: strings.AppProfileRegister.Labels.Status,
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    render: (_, record) => {
      const selectedStatus = statusOption?.find(status => {
        if (record?.isVerified && record?.status === statusEnum.Approving) {
          return status.value === statusEnum.Approved;
        } return status.value === record?.status && status.value !== "";
      });
      return (
        <span
          style={{
            color: selectedStatus?.color,
            fontWeight: 'bold'
          }}
        >
          {selectedStatus?.label}
        </span>
      )
    },
  },
  {
    title: strings.AppProfileRegister.Labels.ApprovedBy,
    dataIndex: 'approvedBy',
    key: 'approvedBy',
    align: 'center',
    render: (_, record) => record?.approvedBy?.email,
  },
  {
    title: strings.AppProfileRegister.Labels.Type,
    dataIndex: 'type',
    key: 'type',
    align: 'center',
    render: (item) => <span>
      {typeOption?.find(type => type.value === item && type.value !== "")?.label}
    </span>,
  },
  // {
  //   title: strings.AppProfileRegister.Labels.VerifiedStatus,
  //   dataIndex: 'isVerified',
  //   key: 'isVerified',
  //   align: 'center',
  //   render: (item) => <span
  //     style={{
  //       color: verifyStatusOption?.find(status => status.value === item && status.value !== "")?.color,
  //       fontWeight: 'bold'
  //     }}
  //   >
  //     {verifyStatusOption?.find(status => status.value === item && status.value !== "")?.label}
  //   </span>,
  // },
  {
    title: strings.AppProfileRegister.Labels.Time,
    dataIndex: 'createdAt',
    key: 'createdAt',
    align: 'center',
    render: (item) => dayjs(item).format('DD-MM-YYYY HH:mm:ss'),
  },
];

const participantsColumns: ColumnsType<ParticipantsModel> = [
  {
    title: strings.AppProfileRegister.Labels.Participants.PhoneNumber,
    dataIndex: 'phoneNumber',
    key: 'phoneNumber',
    align: 'center',
  },
  {
    title: strings.AppProfileRegister.Labels.Participants.Code,
    dataIndex: 'code',
    key: 'code',
    align: 'center',
  },
  {
    title: strings.AppProfileRegister.Labels.Participants.RecipentCode,
    dataIndex: 'recipentCode',
    key: 'recipentCode',
    align: 'center',
  },
  {
    title: strings.AppProfileRegister.Labels.Participants.Type,
    dataIndex: 'type',
    key: 'type',
    align: 'center',
    render: (_, record) => <span>
      {participantTypeOption?.find(type => type.value === record?.type && type.value !== "")?.label}
    </span>,
  },
  {
    title: strings.AppProfileRegister.Labels.Participants.Status,
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    render: (_, record) => <span
      style={{
        color: participantStatusOption?.find(status => status.value === record?.status && status.value !== "")?.color,
        fontWeight: 'bold'
      }}
    >
      {participantStatusOption?.find(status => status.value === record?.status && status.value !== "")?.label}
    </span>,
  },
  {
    title: strings.AppProfileRegister.Labels.Time,
    dataIndex: 'createdAt',
    key: 'createdAt',
    align: 'center',
    render: (item) => dayjs(item).format('DD-MM-YYYY HH:mm:ss'),
  },
];

const getAssetsLabel = (classify?: AssetsClassify) => {
  switch (classify) {
    case AssetsClassify.avatar:
      return strings.AppProfileRegister.Labels.AssetsClassify.Avatar;
    case AssetsClassify.idCard:
      return strings.AppProfileRegister.Labels.AssetsClassify.IdCard;
    case AssetsClassify.contract:
      return strings.AppProfileRegister.Labels.AssetsClassify.Contract;
    case AssetsClassify.businessCerts:
      return strings.AppProfileRegister.Labels.AssetsClassify.BusinessCerts;
    default:
      return strings.AppProfileRegister.Labels.AssetsClassify.Default;
  }
}

export const AppProfileRegisterConstants = {
  filterAttributes,
  columns,
  statusOption,
  statusEnum,
  typeOption,
  verifyStatusOption,
  participantTypeOption,
  participantStatusOption,
  participantStatusEnum,
  participantTypeEnum,
  participantsColumns,
  getAssetsLabel
};
